export const PRIMARY_LANGUAGE_CODE = 'ru';

